export default {
  specialization: {
    type: Object,
    default: () => ({})
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-company-professional/components/specializations/resources/props.js